/**
 * ErrorBoundary.tsx
 * ----------------
 * Handles unhandled exceptions further down in the component tree.
 * Implemented based on React docs: https://reactjs.org/docs/error-boundaries.html
 */

import * as React from 'React';

interface ErrorBoundaryState {
    hasError: boolean;
}

export class ErrorBoundary extends React.Component<{}, ErrorBoundaryState> {

    constructor (props: {}) {
        super(props);

        this.state = { hasError: false };
    }

    static getDerivedStateFromError (): ErrorBoundaryState {
        return { hasError: true };
    }

    componentDidCatch (error: Error, errorInfo: React.ErrorInfo) {
        // TODO: log as exception
        console.error('Native error', error);
        console.error('React error', errorInfo);
    }

    render () {
        const { children } = this.props;
        const { hasError } = this.state;

        if (hasError) {
            // Note: we're consciously not using other components in case they were the cause of the error
            return (
                <div className="error-boundary">
                    <h1 className="error-boundary__title">
                        Something went wrong!
                    </h1>

                    <div className="error-boundary__content">
                        Please check the console for more detailed information.
                    </div>
                </div>
            );
        }

        return children;
    }

}
